/**
 * Main entry point - loads on all pages
 * Universal components: header, modals, FABs, search, sort dropdowns
 */
import { onReady, $, $$ } from '@utils/dom.js';

// ============================================================================
// HEADER MENU & BURGER
// ============================================================================
function initBurgerMenu() {
  const menuButtonContainer = $('.menu-button-container');
  if (!menuButtonContainer) return;

  menuButtonContainer.onclick = function() {
    $('.menu-button')?.classList.toggle('clicked');
    document.body.classList.toggle('fixed');
    $('.burger_darkmod')?.classList.toggle('visible');
    $('.search')?.classList.toggle('hidden');
    $('.burger-items')?.classList.toggle('visible');
    $('.search_icon')?.classList.toggle('hidden');
  };
}

// ============================================================================
// SORT DROPDOWNS (Articles page)
// ============================================================================
function positionSortDropdown(btn, menu) {
  const rect = btn.getBoundingClientRect();
  menu.style.top = (rect.bottom + 8) + 'px';
  menu.style.right = (window.innerWidth - rect.right) + 'px';
}

function closeSortDropdowns() {
  $$('.sort-dropdown-menu.open').forEach(menu => menu.classList.remove('open'));
  $$('.sort-toggle-btn[aria-expanded="true"]').forEach(btn => {
    btn.setAttribute('aria-expanded', 'false');
  });
}

function initSortDropdowns() {
  // Event delegation for sort toggle buttons - works after HTMX swaps
  document.body.addEventListener('click', function(e) {
    const btn = e.target.closest('.sort-toggle-btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      const sortToggle = btn.closest('.sort-toggle');
      const menu = sortToggle?.querySelector('.sort-dropdown-menu');

      if (menu) {
        // Close all other dropdowns first
        $$('.sort-toggle').forEach(other => {
          if (other !== sortToggle) {
            const otherMenu = other.querySelector('.sort-dropdown-menu');
            const otherBtn = other.querySelector('.sort-toggle-btn');
            otherMenu?.classList.remove('open');
            otherBtn?.setAttribute('aria-expanded', 'false');
          }
        });

        const isOpen = menu.classList.toggle('open');
        btn.setAttribute('aria-expanded', isOpen);
        if (isOpen) {
          positionSortDropdown(btn, menu);
        }
      }
      return;
    }

    // Close on option select
    const sortOption = e.target.closest('.sort-option');
    if (sortOption) {
      const menu = sortOption.closest('.sort-dropdown-menu');
      const sortToggle = sortOption.closest('.sort-toggle');
      const toggleBtn = sortToggle?.querySelector('.sort-toggle-btn');
      menu?.classList.remove('open');
      toggleBtn?.setAttribute('aria-expanded', 'false');
      return;
    }

    // Close all dropdowns on click outside
    if (!e.target.closest('.sort-toggle')) {
      closeSortDropdowns();
    }
  });

  // Reposition on scroll/resize
  window.addEventListener('scroll', function() {
    $$('.sort-dropdown-menu.open').forEach(menu => {
      const sortToggle = menu.closest('.sort-toggle');
      const btn = sortToggle?.querySelector('.sort-toggle-btn');
      if (btn) positionSortDropdown(btn, menu);
    });
  }, true);

  window.addEventListener('resize', function() {
    $$('.sort-dropdown-menu.open').forEach(menu => {
      const sortToggle = menu.closest('.sort-toggle');
      const btn = sortToggle?.querySelector('.sort-toggle-btn');
      if (btn) positionSortDropdown(btn, menu);
    });
  });
}

// ============================================================================
// SEARCH FUNCTIONALITY
// ============================================================================
function search_toggle() {
  const searchElement = $('.search');
  searchElement?.classList.toggle('opened');
  $('.search_fade')?.classList.toggle('disabled');

  // Clear search results when closing
  if (!searchElement?.classList.contains('opened')) {
    const searchResults = $('#search-results-dropdown');
    if (searchResults) {
      searchResults.innerHTML = '';
      searchResults.classList.remove('active');
    }
  }
}

// Expose globally for inline onclick
window.search_toggle = search_toggle;

// ============================================================================
// LOGIN/SIGNUP MODALS
// ============================================================================
function login_open() {
  $('#login_popup')?.classList.remove('disabled');
}

function login_close() {
  $('#login_popup')?.classList.add('disabled');
}

function signup_open() {
  $('#signup_popup')?.classList.remove('disabled');
}

function signup_close() {
  $('#signup_popup')?.classList.add('disabled');
}

// Expose globally for inline onclick and HTMX triggers
window.login_open = login_open;
window.login_close = login_close;
window.signup_open = signup_open;
window.signup_close = signup_close;

// Handle HTMX loginRequired trigger
document.addEventListener('loginRequired', function(e) {
  console.log('loginRequired event received');
  login_open();
});

// ============================================================================
// FABs (Floating Action Buttons)
// ============================================================================
function fab_scroll_top() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function fab_scroll_articles_comments() {
  $('.comments_field')?.scrollIntoView();
}

// Expose globally for inline onclick
window.fab_scroll_top = fab_scroll_top;
window.fab_scroll_articles_comments = fab_scroll_articles_comments;

function initFABs() {
  const fabContainer = $('.fab_container');
  if (!fabContainer) return;

  window.onscroll = function() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      fabContainer.classList.remove('hided');
    } else {
      fabContainer.classList.add('hided');
    }
  };
}

// ============================================================================
// INITIALIZE ALL
// ============================================================================
onReady(() => {
  initBurgerMenu();
  initSortDropdowns();
  initFABs();
});

export default {};
